const EmptyRow = ({ _className }) => {
    return <tr className={_className} style={{ height: "0px", maxHeight: "0px" }}></tr>;
};

export { EmptyRow };
